import React from "react";
import { getAppsmithConfigs } from "ee/configs";
import {
  default as CE_EmbedSnippetTab,
  AppSettings,
  ShareModal,
} from "ce/pages/Applications/EmbedSnippetTab";
import { getIsAiAgentFlowEnabled } from "ee/selectors/aiAgentSelectors";
import { useSelector } from "react-redux";
export * from "ce/pages/Applications/EmbedSnippetTab";

const { cloudHosting } = getAppsmithConfigs();

interface EmbedSnippetTabProps
  extends React.ComponentProps<typeof CE_EmbedSnippetTab> {
  isAppSettings?: boolean;
}

export function EmbedSnippetTab(props: EmbedSnippetTabProps) {
  const { isAppSettings } = props;
  const isAiAgentFlowEnabled = useSelector(getIsAiAgentFlowEnabled);

  if (cloudHosting && !isAiAgentFlowEnabled) {
    return <CE_EmbedSnippetTab {...props} />;
  }

  if (isAppSettings) return <AppSettings />;

  return <ShareModal />;
}

export default EmbedSnippetTab;
